<template>
  <SideBarLayout appname="DashBoard">
    <template v-slot:main>
      <div class="p-5">
        <div class="w-full flex items-center justify-evenly bg-black rounded-3xl">
          <button @click="tab='client'" class=" mt-12 hover:text-pink-900">
            <div class=" h-32 w-32 rounded-full bg-white">
              <img src="@/assets/icons8-user-100.png" class="w-full h-full">
            </div>
            <div class="w-full flex flex-col items-center justify-center mt-5">
              <span :class="tab=='client' ? 'text-pink-500' : 'text-white'" class=" text-3xl font-semibold">Client</span>
              <img v-if="tab=='client'" src="@/assets/icons8-sort-down-100.png" class="w-full h-full mt-4">
              <div v-else class="w-full h-full my-10"></div>
            </div>
          </button>
          <button @click="tab='classes'" class="mt-12 hover:text-pink-900">
            <div class=" h-32 w-32 rounded-full bg-white">
              <img src="@/assets/icons8-list-100.png" class="w-full h-full">
            </div>
            <div class="w-full flex flex-col items-center justify-center mt-5">
              <span :class="tab=='classes' ? 'text-pink-500' : 'text-white'" class="text-3xl font-semibold">Classes</span>
              <img v-if="tab=='classes'" src="@/assets/icons8-sort-down-100.png" class="w-full h-full mt-4">
              <div v-else class="w-full h-full my-10"></div>
            </div>
          </button>
          <button @click="tab='coaches'" class="mt-12 hover:text-pink-900">
            <div class=" h-32 w-32 rounded-full bg-white">
              <img src="@/assets/icons8-barbell-100.png" class="w-full h-full">
            </div>
            <div class="w-full flex flex-col items-center justify-center mt-5">
              <span :class="tab=='coaches' ? 'text-pink-500' : 'text-white'" class="text-3xl font-semibold">Coaches</span>
              <img v-if="tab=='coaches'" src="@/assets/icons8-sort-down-100.png" class="w-full h-full mt-4">
              <div v-else class="w-full h-full my-10"></div>
            </div>
          </button>

          <button @click="tab='attendance'" class="mt-12 hover:text-pink-900">
            <div class=" h-32 w-32 rounded-full bg-white">
              <img src="@/assets/icons8-check-100.png" class="w-full h-full">
            </div>
            <div class="w-full flex flex-col items-center justify-center mt-5">
              <span :class="tab=='attendance' ? 'text-pink-500' : 'text-white'" class="text-3xl font-semibold">Attend.</span>
              <img v-if="tab=='attendance'" src="@/assets/icons8-sort-down-100.png" class="w-full h-full mt-4">
              <div v-else class="w-full h-full my-10"></div>
            </div>
          </button>
          
          <button @click="tab='sales'" class="mt-12 hover:text-pink-900">
            <div class=" h-32 w-32 rounded-full bg-white">
              <img src="@/assets/icons8-money-100.png" class="w-full h-full">
            </div>
            <div class="w-full flex flex-col items-center justify-center mt-5">
              <span :class="tab=='sales' ? 'text-pink-500' : 'text-white'" class="text-3xl font-semibold">Sales</span>
              <img v-if="tab=='sales'" src="@/assets/icons8-sort-down-100.png" class="w-full h-full mt-4">
              <div v-else class="w-full h-full my-10"></div>
            </div>
          </button>
        </div>

        <div v-if="tab=='client'" class="mt-5 w-full">
          <LoadQuery v-slot="{data}" :query="'DashBoard/get-client'" :variables="null">
            <div v-if="data!=null">
              <div class="flex gap-5 mb-5">
                <div class="w-full bg-black p-10 rounded-3xl flex">
                  <div class="w-full flex flex-col items-center justify-center gap-5">
                    <span class="text-pink-500 text-8xl font-bold">{{data.active}}</span> 
                    <span class="text-white text-4xl">
                      Active
                    </span>
                  </div>
                  <div class="w-full flex items-center justify-center">
                    <img src="@/assets/icons8-exercise-100.png" class="h-full">
                  </div>
                </div>
                <div class="w-full bg-black p-10 rounded-3xl flex">
                  <div class="w-full flex flex-col items-center justify-center gap-5">
                    <span class="text-pink-500 text-8xl font-bold">{{data.renewal}}</span> 
                    <button @click="showforrenewallist=true">
                      <span class="text-white text-4xl underline">
                        For Renewal
                      </span>
                    </button>
                  </div>
                  <div class="w-full flex items-center justify-center">
                    <img src="@/assets/icons8-weightlifting-100.png" class="h-full">
                  </div>
                </div>
              </div>
              <div class="flex gap-5 mb-5">
                <div class="w-full bg-black p-10 rounded-3xl flex">
                  <div class="w-full flex flex-col items-center justify-center gap-5">
                    <span class="text-pink-500 text-8xl font-bold">{{data.newclient}}</span> 
                    <span class="text-white text-4xl">
                      New
                    </span>
                  </div>
                  <div class="w-full flex items-center justify-center">
                    <img src="@/assets/icons8-fitness-100.png" class="h-full">
                  </div>
                </div>
                <div class="w-full bg-black p-10 rounded-3xl flex">
                  <div class="w-full flex flex-col items-center justify-center gap-5">
                    <span class="text-pink-500 text-8xl font-bold">{{data.walkinclient}}</span> 
                    <span class="text-white text-4xl">
                      Walk-In
                    </span>
                  </div>
                  <div class="w-full flex items-center justify-center">
                    <img src="@/assets/icons8-stretching-100.png" class="h-full">
                  </div>
                </div>
              </div>
            </div>
          </LoadQuery>
        </div>

        <div v-if="tab=='classes'" class="mt-5 w-full">
          <LoadQuery v-slot="{data}" :query="'DashBoard/get-classes'" :variables="null">
            <div v-if="data!=null">
              <div class="flex gap-5 mb-5">
                <div class="w-full bg-black p-10 rounded-3xl flex flex-col">
                  <span class=" text-white text-5xl mt- font-bold mb-10">On Going PT</span>
                  <div v-for="item,index in data.ongoingpt" :key="index" class="w-full">
                    <div class="flex gap-3 items-center w-full bg-pink-900 text-white p-5 text-lg rounded-3xl mb-3">
                      <div class="flex items-center justify-center w-full">
                          <span class="text-3xl">{{ tConvert(item.startTime) }} - {{ tConvert(item.endTime) }}</span>
                      </div>
                      <div class="flex items-start justify-center flex-col w-full gap-2">
                          <span class="text-2xl">{{ item.description }}</span>
                          <span  class="text-2xl">{{ item.coachName }}</span>
                      </div>
                    </div>
                  </div>
                  <span class=" text-white text-5xl mt- font-bold mb-10 mt-5">On Going Class</span>

                  <div v-for="item,index in data.ongoingclass" :key="index" class="w-full">
                    <div class="flex gap-3 items-center w-full bg-pink-900 text-white p-5 text-lg rounded-3xl mb-3">
                      <div class="flex items-center justify-center w-full">
                          <span class="text-3xl">{{ tConvert(item.timeStart) }} - {{ tConvert(item.timeEnd) }}</span>
                      </div>
                      <div class="flex items-start justify-center flex-col w-full gap-2">
                          <span class="text-2xl">{{ item.description }}</span>
                          <span  class="text-2xl">{{ item.coachName }}</span>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="w-full bg-black p-10 rounded-3xl flex flex-col">
                  <span class=" text-white text-5xl mt- font-bold mb-10">Pending PT</span>
                  <div v-for="item,index in data.pendingpt" :key="index" class="w-full">
                    <div class="flex gap-3 items-center w-full bg-gray-900 text-white p-5 text-lg rounded-3xl mb-3">
                      <div class="flex items-center justify-center w-full">
                          <span class="text-3xl">{{ tConvert(item.startTime) }} - {{ tConvert(item.endTime) }}</span>
                      </div>
                      <div class="flex items-start justify-center flex-col w-full gap-2">
                          <span class="text-2xl">{{ item.description }}</span>
                          <span  class="text-2xl">{{ item.coachName }}</span>
                      </div>
                    </div>
                  </div>
                  
                  <span class=" text-white text-5xl mt- font-bold mb-10 mt-5">Pending Class</span>

                  <div v-for="item,index in data.pendingclass" :key="index" class="w-full">
                    <div class="flex gap-3 items-center w-full bg-gray-900 text-white p-5 text-lg rounded-3xl mb-3">
                      <div class="flex items-center justify-center w-full">
                          <span class="text-3xl">{{ tConvert(item.timeStart) }} - {{ tConvert(item.timeEnd) }}</span>
                      </div>
                      <div class="flex items-start justify-center flex-col w-full gap-2">
                          <span class="text-2xl">{{ item.description }}</span>
                          <span  class="text-2xl">{{ item.coachName }}</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </LoadQuery>
        </div>

        <div v-if="tab=='coaches'" class="mt-5 w-full">
          <LoadQuery v-slot="{data}" :query="'DashBoard/get-coachschedule'" :variables="null">
            <div v-if="data!=null">
              <div class="w-full bg-black rounded-3xl p-10">

                <div class="rounded-3xl">
                  <table class="w-full">
                    <thead class="border-b border-b-white">
                      <th class="text-white text-2xl text-left p-5">Name</th>
                      <th class="text-white text-2xl text-left p-3">Schedule Description</th>
                      <th class="text-white text-2xl text-left p-3">Specialize in</th>
                    </thead>
                    <tbody>
                      <tr v-for="item, index in data.activecoaches" :key="index">
                        <td class="text-pink-600 text-2xl text-left p-3">{{ item.name }}</td>
                        <td class="text-pink-600 text-2xl text-left p-3">{{ item.scheddescription }}</td>
                        <td class="text-pink-600 text-2xl text-left p-3">{{ item.specialize }}</td>
                      </tr>
                    </tbody>
                    <tbody>
                      
                      <tr v-for="item, index in data.waitingcoaches" :key="index">
                        <td class="text-white text-2xl text-left p-3">{{ item.name }}</td>
                        <td class="text-white text-2xl text-left p-3">No Schedule Today</td>
                        <td class="text-white text-2xl text-left p-3">{{ item.specialize }}</td>
                      </tr>
                      
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </LoadQuery>
        </div>

        <div v-if="tab=='attendance'" class="mt-5 w-full">
          <LoadQuery v-slot="{data}" :query="'DashBoard/get-attendancelog'" :variables="null">
            <div v-if="data!=null">
              <div class="w-full bg-black rounded-3xl p-10">
               
                  <div class="rounded-3xl">
                    <table class="w-full">
                      <thead class="border-b border-b-white">
                        <th class="text-pink-500 text-2xl text-left p-5">Client</th>
                        <th class="text-white text-2xl text-left p-3">Time In</th>
                        <th class="text-white text-2xl text-left p-3">Status</th>
                      </thead>
                      <tbody>
                        <tr v-for="item, index in data.attendancelog" :key="index">
                          <td class="text-white text-2xl text-left p-3">{{ item.name }}</td>
                          <td class="text-white text-2xl text-left p-3">{{ item.timein }}</td>
                          <td :class="{'text-pink-500 ':item.checktype!=0 ,'text-white':item.checktype==0}" class="text-2xl text-left p-5">{{ item.checktype == 0 ? "IN" : "OUT" }} - {{ item.status }}</td>
                        </tr>
                        
                      </tbody>
                    </table>
                  </div>
              </div>
            </div>
          </LoadQuery>
        </div>

        <div v-if="tab=='sales'" class="mt-5 w-full">
          <LoadQuery v-slot="{data}" :query="'DashBoard/get-sales'" :variables="null">
            <div v-if="data!=null" class="flex gap-5">
              <div class=" w-2/5">
                <div class="w-full flex justify-center">
                  <span class="text-pink-600 text-4xl font-bold">SALES</span>
                </div>
                <div class="w-full bg-black p-10 rounded-3xl flex flex-col mb-5 mt-5">
                  <span class="text-pink-600 text-5xl font-bold">&#x20B1; {{ data.totalsales|currencyformat }}</span>
                  <span class="text-white text-4xl mt-5">Membership</span>
                </div>
                <div class="w-full bg-black p-10 rounded-3xl flex flex-col mb-5">
                  <span class="text-pink-600 text-5xl font-bold">&#x20B1; {{ data.totalmpsales|currencyformat }}</span>
                  <span class="text-white text-4xl mt-5">Merchandise</span>
                </div>
              </div>
              <div class=" w-3/5">
                <div class="w-full flex justify-center">
                  <span class="text-pink-600 text-4xl font-bold">MERCHANDISE INVENTORY</span>
                </div>
                <div class="w-full bg-black p-10 rounded-3xl flex flex-col mb-5 mt-5">
                  <table class="w-full">
                    <thead class="border-b border-b-white">
                      <th class="text-pink-600 text-2xl text-left p-3">Items</th>
                      <th class="text-white text-2xl text-left p-3">Beginning</th>
                      <th class="text-white text-2xl text-left p-3">Ending</th>
                      <th class="text-white text-2xl text-left p-3">Offtake</th>
                    </thead>
                    <tbody v-for="item,index in data.salesbygroup" :key="index">
                      <tr>
                        <td  class="text-pink-600 text-2xl text-left p-3 font-bold">{{ item.groupname }}</td>
                      </tr>
                      <tr v-for="item2,index2 in item.transactions" :key="index2">
                        <td  class="text-white text-2xl text-left p-3">{{ item2.itemname }}</td>
                        <td  class="text-white text-2xl text-left p-3">{{ item2.beginning|currencyformat }}</td>
                        <td  class="text-white text-2xl text-left p-3">{{ item2.ending|currencyformat }}</td>
                        <td  class="text-white text-2xl text-left p-3">{{ item2.offtake|currencyformat }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </LoadQuery>
        </div>
        <ForRenewalListVue :showModal="showforrenewallist"  @onClose="showforrenewallist=false"></ForRenewalListVue>
      </div>
    </template>
  </SideBarLayout>
</template>
<script>

  import SideBarLayout from '@/layout/SideBarLayout.vue'
  import LoadQuery from '@/components/LoadQuery.vue';
  import membership from '@/mixin/membership';
  import ForRenewalListVue from '@/components/forms/ForRenewalList.vue';

  export default{
    mixins:[membership],
    components:{
      SideBarLayout,
      LoadQuery,
      ForRenewalListVue
    },
    data(){
      return{
        tab: "client",
        showforrenewallist: false
      }
    }
  }

</script>

